import type { JSX, ReactNode } from 'react';
import { useMemo } from 'react';
import type { PatientEpisodeCategoryContextValue } from './patientEpisodeCategoryContext';
import { PatientEpisodeCategoryContext } from './patientEpisodeCategoryContext';

type PatientEpisodeCategoryContextProviderProps = PatientEpisodeCategoryContextValue & {
    readonly children: ReactNode;
};

export function PatientEpisodeCategoryContextProvider(props: PatientEpisodeCategoryContextProviderProps): JSX.Element {
    const { children, ...contextValueProps } = props;
    const contextValue = useMemo(() => contextValueProps, Object.values(contextValueProps));

    return (
        <PatientEpisodeCategoryContext.Provider value={contextValue}>{children}</PatientEpisodeCategoryContext.Provider>
    );
}
